import React, { useMemo } from "react";
import { MenuItem } from "@mui/material";
import { MaterialReactTable } from "material-react-table";

import { formatCurrency } from "../../Utils/Currency";
import { renderStatus, SOActionButton } from "./SOActionButton";

function SOItemTable({
  items,
  salesorderPermission,
  onEdit,
  onRequest,
  onApprove,
  onStockOut,
}) {
  const hasApprovedOrCompleted = items.some(
    (item) =>
      item.status?.toLowerCase() === "approved" ||
      item.status?.toLowerCase() === "completed",
  );

  const itemColumns = useMemo(
    () => [
      {
        accessorKey: "sku",
        header: "SKU",
      },
      {
        accessorKey: "item",
        header: "Product",
      },
      {
        accessorKey: "netQty",
        header: "Available Quantity",
      },
      {
        accessorKey: "orderedquantity",
        header: "Requested Quantity",
      },
      {
        accessorKey: "approvedquantity",
        header: "Approved Quantity",
      },
      {
        accessorKey: "unitPrice",
        header: "Unit Price",
        Cell: ({ cell }) => formatCurrency(cell.getValue()),
      },
      {
        accessorKey: "total",
        header: "Total",
        Cell: ({ cell }) => formatCurrency(cell.getValue()),
      },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ cell }) => renderStatus(cell.getValue()),
      },
      {
        accessorKey: "action",
        header: "Actions",
        Cell: ({ cell, row }) => (
          <SOActionButton
            action={cell.getValue()}
            rowData={row.original}
            parentRow={row.original.parentData}
            salesorderPermission={salesorderPermission}
            onRequest={() => onRequest(row.original, row.original.parentData)}
            onApprove={() => onApprove(row.original, row.original.parentData)}
            onStockOut={() => onStockOut(row.original, row.original.parentData)}
          />
        ),
      },
    ],
    [salesorderPermission, onRequest, onApprove, onStockOut],
  );

  return (
    <div
      style={{
        padding: "16px 24px",
        background: "#FAFAFA",
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      <MaterialReactTable
        columns={itemColumns}
        data={items}
        state={{
          columnVisibility: {
            approvedquantity: hasApprovedOrCompleted,
          },
        }}
        enableTopToolbar={false}
        enableBottomToolbar={false}
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enablePagination={false}
        enableSorting={false}
        enableColumnFilters={false}
        enableRowActions
        positionActionsColumn="first"
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "",
            size: 40,
          },
        }}
        renderRowActionMenuItems={({ row, closeMenu }) => {
          if (row.original.status !== "Pending") return [];

          return [
            <MenuItem
              key="edit"
              onClick={() => {
                closeMenu();
                onEdit(row.original, row.original.parentData);
              }}
            >
              <i className="bx bxs-edit me-2" />
              Edit
            </MenuItem>,
          ];
        }}
        muiTableHeadCellProps={{
          sx: {
            fontWeight: "600",
            fontSize: "14px",
          },
        }}
        muiTablePaperProps={{
          elevation: 0,
          sx: {
            boxShadow: "none",
            border: "1px solid #E5E7EB",
          },
        }}
      />
    </div>
  );
}

export default SOItemTable;
